import { FaSearch } from "react-icons/fa";
import Button from "../elements/Button";
import React, { useState } from "react";
import toastr from "../lib/toastr";
import { Collapse, Spinner } from "reactstrap";
import data from "../../constants/gene.json";
import InfoAlert from "../elements/InfoAlert";

const Search = () => {
  const [isOpenSearchResult, setIsOpenSearchResult] = useState(false);

  const [isShowLoader, setIsShowLoader] = useState(false);
  const [searchToken, setSearchToken] = useState("");
  const [searchResult_Title, setSearchResult_Title] = useState("");
  const [searchResult_Phenotype, setSearchResult_Phenotype] = useState("");
  const [searchResult_Treatment, setSearchResult_Treatment] = useState("");
  const [searchResult_Fda, setSearchResult_Fda] = useState("");
  const [searchResult_Evidence, setSearchResult_Evidence] = useState("");
  const [searchResult_Reference, setSearchResult_Reference] = useState("");

  const changeSearchItemHandler = (e) => {
    setSearchToken(e.target.value);
    if (e.target.value.trim().length > 0) {
      e.target.classList.remove("error");
    }
  };
  const resetSearchResult = () => {
    setSearchResult_Title("");
    setSearchResult_Phenotype("");
    setSearchResult_Treatment("");
    setSearchResult_Fda("");
    setSearchResult_Evidence("");
    setSearchResult_Reference("");
  };

  const submitHandler = (e) => {
    e.preventDefault();
    resetSearchResult();
    setIsOpenSearchResult(false);
    if (searchToken.trim().length > 0) {
      setIsShowLoader(!isShowLoader);
      const result = data.gene.find(
        (x) =>
          x.title.trim().toLocaleLowerCase() ===
          searchToken.trim().toLocaleLowerCase()
      );
      if (result) {
        setSearchResult_Title(result.title);
        let temp = result.phenotype.split("#");
        if (temp.length > 0) {
          setSearchResult_Phenotype(
            temp
              .map((item) => {
                return `<div class="body-item"><p><span class="circle-symbol">● </span> ${item}</p></div>`;
              })
              .join("")
          );
        }
        temp = result.treatment.split("#");
        if (temp.length > 0) {
          setSearchResult_Treatment(
            temp
              .map((item) => {
                return `<div class="body-item"><p><span class="circle-symbol">● </span> ${item}</p></div>`;
              })
              .join("")
          );
        }
        if (result.fda) {
          temp = result.fda.split("#");
          if (temp.length > 0) {
            setSearchResult_Fda(
              temp
                .map((item) => {
                  return `<div class="body-item"><p><span class="circle-symbol">● </span> ${item}</p></div>`;
                })
                .join("")
            );
          }
        }

        if (result.evidence) {
          temp = result.evidence.split("#");
          if (temp.length > 0) {
            setSearchResult_Evidence(
              temp
                .map((item) => {
                  return `<div class="body-item"><p><span class="circle-symbol">● </span> ${item}</p></div>`;
                })
                .join("")
            );
          }
        }

        if (result.reference) {
          temp = result.reference.split(",");
          if (temp.length > 0) {
            setSearchResult_Reference(
              temp
                .map((item) => {
                  return `<div class="body-item"><p><span class="circle-symbol">● </span><a href="https://pubmed.ncbi.nlm.nih.gov/${item.replace(
                    " ",
                    ""
                  )}/" target="_blank">
               ${item}
               </a>
             </p></div>`;
                })
                .join("")
            );
          }
        }

        setIsShowLoader(false);
        setIsOpenSearchResult(true);
      } else {
        toastr.error("Your search did not return any results .");
        setIsShowLoader(false);
      }
    } else {
      document.getElementsByName("seachItem")[0].classList.add("error");
      toastr.error("Enter the gene name");
    }
  };
  return (
    <div className="col-12">
      <div className="search-box">
        <form onSubmit={(e) => submitHandler(e)}>
          <div className="row">
            <div className="col-xs-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <div className="search-box-holder">
                <input
                  disabled={isShowLoader}
                  name="seachItem"
                  type="text"
                  onChange={(e) => changeSearchItemHandler(e)}
                  value={searchToken}
                  placeholder="Enter the gene name"
                  autoComplete="off"
                  maxLength="50"
                  className={`form-control input-text ${
                    isShowLoader ? "disabled" : ""
                  }`}
                />
                <Button
                  type="submit"
                  exteraClass="search-btn"
                  isDisabled={isShowLoader}
                >
                  {isShowLoader ? (
                    <Spinner size="sm" className="mx-2" />
                  ) : (
                    <FaSearch size="16px" className="mx-2" />
                  )}
                  Search
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Collapse isOpen={isOpenSearchResult}>
        <div className="search-result">
          <div className="row">
            <div className="col-12 mb-2">
              <span className="gene-name">{searchResult_Title}</span>
            </div>
            <div className="col-12">
              <InfoAlert title="Phenotype : ">
                <div
                  dangerouslySetInnerHTML={{ __html: searchResult_Phenotype }}
                />
              </InfoAlert>
              <InfoAlert title="Treatment : ">
                <div
                  dangerouslySetInnerHTML={{ __html: searchResult_Treatment }}
                />
              </InfoAlert>
              {searchResult_Fda.length > 0 ? (
                <InfoAlert title="FDA approval : ">
                  <div dangerouslySetInnerHTML={{ __html: searchResult_Fda }} />
                </InfoAlert>
              ) : null}
              {searchResult_Evidence.length > 0 ? (
                <InfoAlert title="Evidence : ">
                  <div
                    dangerouslySetInnerHTML={{ __html: searchResult_Evidence }}
                  />
                </InfoAlert>
              ) : null}

              <InfoAlert title="Reference (PMID) : ">
                <div
                  dangerouslySetInnerHTML={{ __html: searchResult_Reference }}
                />
              </InfoAlert>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default Search;
